import remote from "../remote/bs.vidaa";

export default function getRemoteKey(keyCode, ctrlKey, altKey) {
  return remote.keyMap[`${ctrlKey ? "CTRL+" : ""}${altKey ? "ALT+" : ""}${keyCode}`];
}
